import React, { useEffect, useRef, useState } from 'react';
import './data-download-modal.styles.scss';
import Modal, { ModalAlert, ModalConfirm } from '@/components/SHARED/modal/modal.component';
import CsvDownload from 'react-json-to-csv';
import DataFilters from './data-filters.component';
import { getCompiledDataFromDb } from '@/utils/getDataFromDb';
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component';
import { format } from 'date-fns';
import { createPurchaseDataPoint } from '@/utils/create-purchase-data-point';

const DataDownloadModal = ({
  show,
  cancel,
  users,
  mcList,
  nfeRegs
}) => {
  
  const [ filter, setFilter ] = useState({});
  const [ alertMessage, setAlertMessage ] = useState(null);
  const [ confirmMessage, setConfirmMessage ] = useState(null);
  const [ compiledData, setCompiledData ] = useState(null);
  const [ clear, setClear ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ headers ] = useState([
    'fName',
    'lName',
    'email',
    'iein',
    'mc_name',
    'type',
    'date',
    'state',
    'ts',
    'mc_key',
    'id',
    'progressId',
    'cst_key'
  ])
  const dataRef = useRef();
  const approveRef = useRef();
  const filterRef = useRef({'callback': callback});

  useEffect(() => {
    if (!show) {
      clearFilter();
      setLoading(false);
    }
  }, [show])

  useEffect(() => {
    if (!compiledData) return;
    document.getElementById('csv-button').click();
    clearFilter();
    setCompiledData(null);
  }, [compiledData])

  function changeFilterOption(key, value) {
    let tempFilter = {...filterRef.current};
    if (!value) {
        delete tempFilter[key];
    } else {
        tempFilter = {
            ...tempFilter,
            ...{[key]: value}
        }
    }
    filterRef.current = {...tempFilter}
    setFilter(filterRef.current);
  }

  function getCompiledDataForDownload() {
    console.log(filterRef.current);
    if (Object.values(filterRef.current).length < 2) {
      setConfirmMessage('You will be downloading all of the data from the beginning of the Micro-Credential program. This is a great deal of data and it may take some time to download. You cannot close this page during this process. Are you sure you want do continue without filters?');
      approveRef.current = () => {
        continueDownload();
      }
    } else {
      continueDownload();
    }

    function continueDownload() {
      console.log('continuing');
      setLoading(true);

      const newFilter = {
        ...{'once': true},
        ...filterRef.current
      }
      console.log(newFilter);
      // return;
      getCompiledDataFromDb(newFilter);      
    }
  }

  function callback(data) {
    console.log(data);
    let compiledArr = [];
    for (let dataPoint of Object.values(data)) {
        let user = users[dataPoint.cst_key];
        let mc = mcList[dataPoint.mc_key];
        if (dataPoint.ts) {
            dataPoint.date = format(new Date(dataPoint.ts), "Pp");
        } else {
            dataPoint.date = 'unknown';
        }
        dataPoint.fName = user ? user.fName : 'unknown';
        dataPoint.lName = user ? user.lName : 'unknown';
        dataPoint.state = user ? user.state : 'unknown';
        dataPoint.email = user ? user.email : 'unknown';
        dataPoint.iein = user && user.iein ? user.iein : '';
        dataPoint.mc_name = mc ? mc.name : 'unknown';
        compiledArr.push(dataPoint);
    }
    dataRef.current = [...compiledArr];
    // setCompiledData(compiledArr);
    // console.log(compiledArr);
    // cancel();

    const tempFilter = {...filterRef.current}
    if (tempFilter.type && tempFilter.type !== 'purchase-completed') {
      organizeColumns();
      // setCompiledData(dataRef.current);
      console.log(compiledArr);
      cancel();
      return;
    }
    addPurchaseData()
  }

  function addPurchaseData() {
    let arr = [];
    let filterObj = {...filterRef.current};
    console.log(filterObj);
    for (let mc_key of Object.keys(nfeRegs)) {
        const regs = nfeRegs[mc_key];
        if (
            filterObj.mc_key &&
            filterObj.mc_key !== mc_key 
        ) continue;
        for (let cst_key of Object.keys(regs)) {
            const purchase = regs[cst_key];
            const ts = new Date(purchase['Registrant.reg_add_date']).getTime();
            if (
                filterObj.cst_key && 
                filterObj.cst_key !== cst_key
            ) continue;
            if (
                filterObj.startDate &&
                filterObj.startDate > ts
            ) continue;
            if (
                filterObj.endDate && 
                filterObj.endDate < ts
            ) continue;
            if (
              filterObj.state &&
              (
                  !users[cst_key] ||
                  users[cst_key].state !== filterObj.state
              )
          ) continue;

            const obj = createPurchaseDataPoint(
                {'add_date': ts},
                users[cst_key],
                mcList[mc_key]
            )
            // console.log(obj);
            if (!obj) continue;
            obj.date = format(new Date(obj.ts), "Pp");
            obj.state = users[cst_key].state;
            obj.email = users[cst_key].email;
            obj.mc_name = mcList[mc_key].name;
            obj.iein = users[cst_key].iein ?? '';
            let tempData = {...dataRef.current}
            if (Object.values(tempData).filter(t => t.progressId === obj.progressId).length !== 0) continue;
            arr.push(obj);
        }
    }
    dataRef.current = [
      ...dataRef.current,
      ...arr
    ];
    organizeColumns();
    cancel();
  }

  function organizeColumns() {
    const tempData = [...dataRef.current];
    let newArr = [];
    for (let data of tempData) {
        let dataArr = [];
        for (let h of headers) {
            dataArr.push(data[h]);
        }
        newArr.push(dataArr);
    }
    setCompiledData(newArr.sort((a,b) => a.ts < b.ts ? 1 : -1));
  }

  function clearFilter() {
    filterRef.current = {'callback': callback}
    setFilter(filterRef.current);
    setClear(true);
  }

  return (
    <div className='data-download-modal'>
      <Modal
        show={show}
        cancel={cancel}
        text='Download Data'
        cls='narrow'
        closeButton={true} >
        {
          (users && mcList) &&
          <div className='data-download-modal-content'>
            <p>Filter the data you want to download.</p>
            <div className='buttons'>
              <button 
                className='g-button small-btn'
                onClick={() => clearFilter()}>
                Clear Filter
              </button>
            </div>
            <div className="g-space-1"></div>
            <DataFilters
              users={users}
              mcList={mcList}
              filter={filter}
              changeFilterOption={changeFilterOption}
              clear={clear}
              setClear={setClear} />
            <div className='g-space-2'></div>
            <div className='buttons'>
              {
                (loading)
                ?
                <button className='g-button disabled'>
                  <ThreeDotsLoader />
                </button>
                :
                <button 
                  className='g-button primary'
                  onClick={() => getCompiledDataForDownload()} >
                  Download Selected Data
                </button>
                }
              <div className='hide'>
                  <CsvDownload
                      id="csv-button"
                      data={compiledData}
                      headers={headers}
                      delimiter=","
                      filename='MC Full Data Download.csv' />
              </div>
            </div>
          </div>
        }
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default DataDownloadModal;